<template>
    <div v-if="active === true" class="transmission alert bg-muted p-sm">
        <div class="progress-striped">
            <div style="width:100%;"
                 role="progressbar"
                 class="progress-bar active"
                 aria-valuemax="100"
                 aria-valuemin="0"
                 :aria-valuenow="100">
                <span>{{ t_active_transmissions }}: {{ transmissions }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                t_active_transmissions: Lang.langGet("Active Transmissions"),
                active: false,
                transmissions: 0
            }
        },
        methods: {
            doTransmissionChecks: function () {
                axios.post('/content/publish/transmission', {
                    project_id: Laravel.activeProject
                }).then((response) => {
                    this.transmissions = parseInt(response.data.data);
                    this.active = this.transmissions > 0;
                }).catch((error) => {
                    if (error.response?.status === 401) {
                        window.location = '/login';
                    }

                    this.active = false;
                });
            }
        },
        mounted() {
            this.doTransmissionChecks();

            setInterval(() => {
                this.doTransmissionChecks();
            }, 3000); // check every 3 seconds
        }
    }
</script>

<style>
.progress-striped > .progress-bar {
    background-repeat: repeat-x !important;
}
</style>
